export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 7,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://192.168.0.147:9980/',
    dev: 'https://beta-gw.mubei.cn/',
    pro: 'https://gw.mjvip.com/'
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: false, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}

export const configApi = {
  sceneApi: {
    // dev: 'https://mall-gw.mubei.cn/',
    dev: 'https://beta-gw.mjvip.com/',
    pro: 'https://gw.mjvip.com/'
  }
}

export const sceneApi = process.env.NODE_ENV === 'development' ? configApi.sceneApi.dev : configApi.sceneApi.pro

/**
 * 收银-用户二维码支付
 * @type {{vipQrCode: {dev: string, pro: string}}}
 */
export const configVipQrCode = {
  vipQrCode: {
    // dev: 'wxa64255397e81d3ce',
    dev: 'wxf0fbbc2a40dad1c2',
    pro: 'wxb9dd45b3b528eaca'
  }
}

export const sceneVipQrCode = process.env.NODE_ENV !== 'dev' ? configVipQrCode.vipQrCode.dev : configVipQrCode.vipQrCode.pro

/**
 * 收银-门店负责人-二维码结账
 * @type {{vipQrCode: {dev: string, pro: string}}}
 */
export const configConsumptionResponsibleQrCode = {

  vipQrCode: {
    // dev: 'wxa64255397e81d3ce',
    dev: 'wxf0fbbc2a40dad1c2',
    pro: 'wx71a1c37c74247b7e'
  }
}

export const sceneResponsibleQrCode = process.env.NODE_ENV !== 'dev' ? configConsumptionResponsibleQrCode.vipQrCode.dev : configConsumptionResponsibleQrCode.vipQrCode.pro

/**
 * 人事-扫码入职
 * @type {{staffQrCode: {dev: string, pro: string}}}
 */
export const configStaffQrCode = {
  staffQrCode: {
    // dev: 'wxa64255397e81d3ce',
    dev: 'wxd11d6e3b306ed7c7',
    pro: 'wxda4e63c5bb2b7da1'
  }
}

export const sceneStaffQrCode = process.env.NODE_ENV !== 'dev' ? configStaffQrCode.staffQrCode.dev : configStaffQrCode.staffQrCode.pro
